import { createJigsawReaderAction } from 'app/api/redux-jigsaw/jigsaw-action';
import { GET_ANCILLARIES } from 'app/api/redux-jigsaw/jigsaw-methods';
import { currentBookHasAncillaries } from 'app/api/redux-jigsaw/jigsaw-selectors';

const getAncillaries = createJigsawReaderAction(GET_ANCILLARIES);

export function tryGetAncillaries() {
  return function(dispatch, getState) {
    if (currentBookHasAncillaries(getState())) {
      dispatch(getAncillaries());
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/ancillaries/actions.js